import { Middleware } from 'redux';

import { sagaMiddleware } from './saga';

export const middlewares: Array<Middleware> = [sagaMiddleware];
